<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}

            <p>
                {{ creditBureau.address_name }} <br />
                {{ creditBureau.street_address }} <br />
                {{ creditBureau.city }}, {{ creditBureau.state_abbrev }}
                {{ creditBureau.zipcode }}
            </p>
            <br />
        </p>
        <p>
            <template v-if="creditBureau.officers">
                <strong>Attn:</strong> {{ creditBureau.officers }} <br />
            </template>
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            I am writing to express my concern regarding the validity and accuracy of your recent investigation of 
            the accounts that are reporting on my credit report. About 30 days ago, I requested an investigation as 
            I believed that certain items were not being reported legally. However, I received a letter a couple of 
            days ago stating that your investigation was complete and that the items listed above were “verified”. 
            I am requesting that you explain to me how you conducted your investigation and provide me with your 
            method of verification. 
        </p>
        <p class="letter-content">
            In your response, please include the following details:
            <ol>
                <li>Please explain what your representatives uncovered to lead them to believe that the item(s) were being reported legally.</li>
                <li>What certified documents were reviewed to conclude your investigation?</li>
                <li>Please provide a complete copy of all the information that was transmitted to the data furnisher as part of the investigation.</li>
                <li>What was the cost incurred by your company to obtain the documents needed to complete your investigation?</li>
                <li>Please provide proof of your timely procurement of certified documents.</li>
                <li>Did you speak directly to any agent of the company that was reporting the information to confirm the accuracy of what you are reporting? If yes, please provide details such as the name, position, date, and duration of the conversation, as well as the telephone number called, and the name and position of the employee who spoke directly to the above party.</li>
                <li>Provide copies of all correspondence and any conclusive documentation to prove that you have conducted a reasonable investigation of the account in question.</li>
                <li>Provide the date of the commencement of delinquency.</li>
                <li>Please provide the specific date on which the items will cease to be reported.</li>
            </ol>
        </p>
        <P class="letter-content">
            I respectfully request a notarized affidavit confirming that the information provided is true and correct, 
            as per my civil rights granted under several federal laws. Please note that a form letter response will not 
            be acceptable, and if you cannot supply all of the above information in a timely manner as detailed in several 
            laws, including but not limited to the Fair Credit Reporting Act, I must immediately demand the permanent removal 
            of this item from my credit report.
        </P>
        <P class="letter-content">
            This erroneous entry is detrimental to my overall credit rating and has caused me severe financial and emotional 
            distress. If you choose not to provide the above-requested deletion or the requested/required documentation of your 
            investigation, I will pursue the enforcement of my constitutional rights via federal court proceedings. I have recently 
            studied constitutional consumer protection laws along with civil/federal court procedures, and I will represent myself
            pro-se and will formally request a jury trial.

        </P>
        <P class="letter-content">
            Enclosed is a list of accounts that you claimed were “verified”. Thank you for your prompt attention to this matter.
        </P>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>

        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash
            };
        },
    };
</script>